export default "__VITE_ASSET__DnnRtPlq__"